import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { AppLazyLoadEvent, AppPost, ShortTermRentalDateTime } from '../../../../models';
import { MatchModesPrime } from '../../../../enums';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAimAdminRoutes } from '../../ngx-aim-admin-admin.routes';
import { AsyncPipe, NgClass } from '@angular/common';
import { NgxAimAdminStrTimeSlotsService } from './ngx-aim-admin-str-time-slots.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { WeekIdToNamePipe } from '../../../../pipes/week-id-to-name/week-id-to-name.pipe';
import { HttpErrorService } from '../../../../services';

@Component({
  selector: 'ngx-aim-admin-str-time-slots',
  standalone: true,
  imports: [
    FormsModule,
    ToolbarModule,
    ConfirmPopupModule,
    DialogModule,
    TableModule,
    TagModule,
    ButtonModule,
    CheckboxModule,
    AsyncPipe,
    NgClass,
    MultiSelectModule,
    WeekIdToNamePipe,
  ],
  templateUrl: './ngx-aim-admin-str-time-slots.component.html',
  styleUrl: './ngx-aim-admin-str-time-slots.component.css',
  providers: [ConfirmationService]
})
export class NgxAimAdminStrTimeSlotsComponent {
  @ViewChild('dt') table: Table | undefined;

  router = inject(Router);
  route = inject(ActivatedRoute);
  entityService = inject(NgxAimAdminStrTimeSlotsService);
  httpErrorService = inject(HttpErrorService);

  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedData: AppPost[] = [];
  selectedOptions: string[] = [];
  showOptions = false;

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  onNewClick() {
    this.openEntity();
  }

  openEntity(entityId?: number) {
    if (entityId) {
      this.router.navigate([NgxAimAdminRoutes.EDIT, entityId], { relativeTo: this.route });
    } else {
      this.router.navigate([NgxAimAdminRoutes.EDIT, 'new'], { relativeTo: this.route });
    }
  }

  onToggleEnabledClick(timeSlot: ShortTermRentalDateTime) {
    this.entityService.toggleEnabled(timeSlot).subscribe({
      error: (err) => this.httpErrorService.onHttpError(err, 'Could not save time slot')
    });
  }
}
